import forge from 'node-forge';

export const encryptMessageWithRSAOAEP = async (message:string, key:string) => {
    try {
      const publicKey = forge.pki.publicKeyFromPem(key);
      const md = forge.md.sha256.create();
      const encrypted = publicKey.encrypt(message, 'RSA-OAEP', { md: md });
      return forge.util.encode64(encrypted);
    } catch (error) {
      console.error('Encryption error:', error);
      return '';
    }
  };